
export const routeMap = {
  '/ai/chat/ai1': 'ai.chat.ai1',
  '/ai/chat/ai2': 'ai.chat.ai2',
  '/ai/chat/claude': 'ai.chat.claude',
  '/ai/chat/gemini': 'ai.chat.gemini',
  '/ai/chat/general': 'ai.chat.general',

  '/ai/art/image': 'ai.art.image',
  '/ai/art/image/history': 'ai.art.image',
  '/ai/art/image2': 'ai.art.image2',
  '/ai/art/image/describe': 'ai.art.imageDescribe',
  '/ai/art/faceswap': 'ai.art.faceswap',
  '/ai/art/image/search': 'ai.art.search',

  '/aigc/xiaohongshu/list': 'ai.aigc.xhs',
  '/aigc/xiaohongshu/create': 'ai.aigc.xhs',
  '/aigc/videoscript/list': 'ai.aigc.videoscript',
  '/aigc/videoscript/create': 'ai.aigc.videoscript',
  '/aigc/copyextract/list': 'ai.aigc.extract',
  '/aigc/copyextract/create': 'ai.aigc.extract',
  '/aigc/outline/list': 'ai.aigc.outline',
  '/aigc/outline/create': 'ai.aigc.outline',
  '/aigc/writing/list': 'ai.aigc.writing',
  '/aigc/writing/create': 'ai.aigc.writing',
  '/aigc/embellish/list': 'ai.aigc.embellish',
  '/aigc/embellish/create': 'ai.aigc.embellish',
  '/aigc/dianping/list': 'ai.aigc.dianping',
  '/aigc/dianping/create': 'ai.aigc.dianping',
  '/aigc/comment/list': 'ai.aigc.comment',
  '/aigc/comment/create': 'ai.aigc.comment',
  '/aigc/insight/list': 'ai.aigc.insight',
  '/aigc/insight/create': 'ai.aigc.insight',
  '/aigc/xhshot/list': 'ai.aigc.xhshot',
  '/aigc/xhshot/create': 'ai.aigc.xhshot',

  '/agent/xhs/list': 'ai.agent.xhs',
  '/agent/xhs/create': 'ai.agent.xhs',
  '/agent/bot/list': 'ai.agent.bot',
  '/agent/bot/view': 'ai.agent.bot',
  '/agent/bot/chat': 'ai.agent.chat',
  '/agent/knowledge/list': 'ai.agent.knowledge',
  '/agent/knowledge/view': 'ai.agent.knowledge',
  '/agent/knowledge/unit/create': 'ai.agent.knowledge',
  '/agent/knowledge/unit/view': 'ai.agent.knowledge',
  '/agent/xhsad/list': 'ai.agent.xhsad',
  '/agent/xhsad/new': 'ai.agent.xhsad',
  '/agent/xhsflow/dashboard': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/brand/list': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/brand/new': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/account/list': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/account/new': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/content/list': 'ai.agent.xhsflow',
  '/agent/xhsflow/strategy/content/new': 'ai.agent.xhsflow',
  '/agent/xhsaccount/list': 'ai.agent.xhsaccount',
  '/agent/xhsaccount/view': 'ai.agent.xhsaccount',
  '/agent/flow/dashboard': 'ai.agent.flist',
  '/agent/flow/history': 'ai.agent.flist',
  '/agent/flow/chat': 'ai.agent.fchat',

  '/data/dy/rank': 'ai.data.dyrank',
  '/data/dy/creative': 'ai.data.dycreative',
  '/data/xhs/view': 'ai.data.xhshot',
  '/data/xhs/kol/list': 'ai.data.xhskol',
  '/data/xhs/kol/detail': 'ai.data.xhskol',
  '/data/dy/kol/list': 'ai.data.dykol',
  '/data/sv/search': 'ai.data.svsearch',
  '/data/util/keyword': 'ai.data.keyword',
  '/data/mlxx/view': 'ai.data.mlxx',
  '/data/xhs/note/list': 'ai.data.xhsnote',

  '/xhs/model/list': 'ai.xhs.model',
  '/xhs/model/view': 'ai.xhs.model',
  '/xhs/model/dataset/list': 'ai.xhs.model.dataset',
  '/xhs/model/dataset/view': 'ai.xhs.model.dataset',
  '/xhs/account/list': 'ai.xhs.account',
  '/xhs/account/view': 'ai.xhs.account',
  '/xhs/launch/list': 'ai.xhs.launch',
  '/xhs/launch/new': 'ai.xhs.launch',
  '/xhs/partner/sub/list': 'ai.xhs.partnersub',

  '/autowrite/account/list': 'ai.autowrite.account',
  '/autowrite/account/import': 'ai.autowrite.account',
  '/autowrite/task/list': 'ai.autowrite.task',
  '/autowrite/task/new': 'ai.autowrite.task',
  '/autowrite/task/view': 'ai.autowrite.task',
  '/autowrite/stat/dashboard': 'ai.autowrite.statistics',
  '/autowrite/stat/task': 'ai.autowrite.statistics',

  '/model/ft/list': 'ai.model.ft',
  '/model/ft/create': 'ai.model.ft',
  '/model/knowledge/list': 'ai.model.knowledge',
  '/model/knowledge/create': 'ai.model.knowledge',
  '/model/knowledge/history': 'ai.model.knowledge',
  '/model/generate/query': 'ai.model.generate',
  '/model/generate/list': 'ai.model.generate',

  '/shortvideo/douyin/post/detail': 'ai.shortvideo.douyin',
  '/shortvideo/douyin/user/view': 'ai.shortvideo.douyin',
  '/shortvideo/tiktok/post/detail': 'ai.shortvideo.tiktok',
  '/shortvideo/xhs/post/detail': 'ai.shortvideo.xhs',

  '/toolkit/instruction': 'ai.toolkit.instruction',
  '/toolkit/imageprompt': 'ai.toolkit.imageprompt',
  '/toolkit/prompt/act': 'ai.toolkit.prompt.act',
  '/toolkit/stt/generate': 'ai.toolkit.stt',
  '/toolkit/stt/list': 'ai.toolkit.stt',
  '/toolkit/tts/generate': 'ai.toolkit.tts',
  '/toolkit/tts/list': 'ai.toolkit.tts',
}
export const directPath = [
    '/help/xhs/auth',
    '/account/info',
    '/toolkit/test',
]
export const loginDirectPath = [
    '/',
    '/ai',
    '/help/tutorial',
    '/ai/forbidden',
    '/ai/test/test'
]
export const accountRoutePath = [
  '/account/list',
  '/account/stat',
  '/account/bill'
]

export default {
  routeMap,
  directPath,
  loginDirectPath,
  accountRoutePath
};